import React, { useState } from 'react';
import Drawer from '@mui/material/Drawer';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import Close from '@mui/icons-material/Close';
import './ride-info.css';

export default function RideInfo({ showLabel = false }) {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return <>
    <button
      type="button"
      className={`ride-info-trigger${showLabel ? ' ride-info-trigger-labeled' : ''}`}
      aria-label="How this ride works"
      aria-haspopup="dialog"
      aria-expanded={open}
      onClick={() => setOpen(true)}
    >
      <InfoOutlined aria-hidden="true" />
      {showLabel && <span>How it works</span>}
    </button>
    <Drawer
      anchor="bottom"
      open={open}
      onClose={close}
      PaperProps={{
        className: 'ride-info-sheet',
        role: 'dialog',
        'aria-modal': true,
        'aria-label': 'How this ride works',
      }}
    >
      <div className="ride-info-handle" aria-hidden="true" />
      <div className="ride-info-heading">
        <div><h2>How this ride works</h2><p>A shared soundtrack, with room for everyone.</p></div>
        <button type="button" className="ride-info-close" onClick={close} aria-label="Close ride information"><Close /></button>
      </div>
      <dl className="ride-info-details">
        <div><dt>Add to the shared queue</dt><dd>Everyone’s picks play in turn. Wait 60s between additions.</dd></div>
        <div><dt>Shape the mix</dt><dd>Choose genres to influence the music for this ride.</dd></div>
        <div><dt>Give each song a moment</dt><dd>Wait 3s after a track changes, and 10s after your skip.</dd></div>
        <div><dt>Stay near your ride</dt><dd>Location is checked to help keep the remote near your driver.</dd></div>
        <div><dt>Spotify is optional</dt><dd>Use the remote as a guest, or connect Spotify.</dd></div>
      </dl>
    </Drawer>
  </>;
}
